export default __webpack_public_path__ + "static/media/digital_platforms_xl.798b7e59.jpg";